exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2Y5Ll4D5logAy-9Twi-Kb1,.TVs4dKaF9KdrIif69LT0r{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.KsdYIndjocZd2WZOoiFO3{position:relative;top:2px;width:32px;height:32px;line-height:28px}html[dir] .KsdYIndjocZd2WZOoiFO3{text-align:center}.I1Yj3poSjsgqfBcXGvCK4{display:inline-block}html[dir=ltr] ._7pYh617id23iKommvo6-x{padding-right:8px}html[dir=rtl] ._7pYh617id23iKommvo6-x{padding-left:8px}", ""]);
// Exports
exports.locals = {
	"locationPersona": "_2Y5Ll4D5logAy-9Twi-Kb1",
	"personaInfoWrapper": "TVs4dKaF9KdrIif69LT0r",
	"roomIcon": "KsdYIndjocZd2WZOoiFO3",
	"hoverTargetStyle": "I1Yj3poSjsgqfBcXGvCK4",
	"readOnlyPill": "_7pYh617id23iKommvo6-x"
};